// Brands
export const setBrandsInChatWithData = (selectedBrands) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRANDS_IN_CHAT_WITH_DATA",
      value: selectedBrands,
    });
  };
};

// Duration
export const setDurationInChatWithData = (duration) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DURATION_IN_CHAT_WITH_DATA",
      value: duration,
    });
  };
};

export const setChatWithDataResponse = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CHAT_WITH_DATA_RESPONSE",
      value: value,
    });
  };
};

export const setChatsAnswerLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CHATS_ANSWER_LOADER",
      value: value,
    });
  };
};

export const setTopicAnswerLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_TOPIC_ANSWER_LOADER",
      value: value,
    });
  };
};

export const setTopicAnswerOnScrollLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_TOPIC_ANSWER_ON_SCROLL_LOADER",
      value: value,
    });
  };
};

export const setChattopicsHistory = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CHAT_TOPICS_HISTORY",
      value: value,
    });
  };
};

export const setChatHistoryLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CHATS_HISTORY_LOADER",
      value: value,
    });
  };
};

export const setStarterQuestions = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STARTER_QUESTIONS",
      value: value,
    });
  };
};
export const setTrendingSuggestionsList = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_TRENDING_SUGGESTIONS_LIST",
      value: value,
    });
  };
};
export const setStarterQuestionsLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STARTER_QUESTIONS_LOADER",
      value: value,
    });
  };
};
export const setTrendingSuggestionsLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_TRENDING_SUGGESTIONS_LOADER",
      value: value,
    });
  };
};

export const setSelectedChatData = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTED_CHAT_DATA",
      value: value,
    });
  };
};

// Brand changed
export const setBrandChanged = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRAND_CHANGED",
      value: value,
    });
  };
};

// Duration changed
export const setDurationChanged = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DURATION_CHANGED",
      value: value,
    });
  };
};

export const setOtpStatusFlag = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_OTP_STATUS_FLAG",
      value: value,
    });
  };
};

export const setSignUpLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SIGN_UP_LOADER",
      value: value,
    });
  };
};
export const setOtpValidateLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_OTP_VALIDATE_LOADER",
      value: value,
    });
  };
};

// Set User Profile Details which we get in get-profile API
export const setUserProfileDetails = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_USER_PROFILE_DETAILS",
      value: value,
    });
  };
};

export const setUserRegionDetails = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_USER_REGION_DETAILS",
      value: value,
    });
  };
};

export const setUserProfileSaveLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_USER_PROFILE_SAVE_LOADER",
      value: value,
    });
  };
};

export const setUserProfileModalFlag = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_USER_PROFILE_MODAL_FLAG",
      value: value,
    });
  };
};

export const setGetVisitorIdLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_GET_VISITOR_ID_LOADER",
      value: value,
    });
  };
};

export const setPaymentProcessLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PAYMENT_PROCESS_LOADER",
      value: value,
    });
  };
};

export const setFollowUpQuestionsLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_FOLLOW_UP_QUESTIONS_LOADER",
      value: value,
    });
  };
};

export const setCreditsCountLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CREDITS_COUNT_LOADER",
      value: value,
    });
  };
};

export const setPlansList = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PLANS_LIST",
      value: value,
    });
  };
};

export const setPlansListLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PLANS_LIST_LOADER",
      value: value,
    });
  };
};

export const setCancelSubscriptionLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CANCEL_SUBSCRIPTION_LOADER",
      value: value,
    });
  };
};

export const setDeleteAccountLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DELETE_ACCOUNT_LOADER",
      value: value,
    });
  };
};

export const setSignInThroughFlag = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SIGN_IN_THROUGH_FLAG",
      value: value,
    });
  };
};

export const setLandingPageQuestionsList = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_LANDING_PAGE_QUESTIONS_LIST",
      value: value,
    });
  };
};

export const setCreditLimitExhausted = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CREDIT_LIMIT_EXHAUSTED",
      value: value,
    });
  };
};

export const setConcurrentLimitReached = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CONCURRENT_LIMIT_REACHED",
      value: value,
    });
  };
};

// Streaming State Actions
export const setReasoningActive = (isActive, queryId) => {
  return (dispatch) => {
    dispatch({
      type: "SET_REASONING_ACTIVE",
      payload: { isActive, queryId },
    });
  };
};

export const setSSEStreaming = (isStreaming, queryId) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SSE_STREAMING",
      payload: { isStreaming, queryId },
    });
  };
};

export const setFinalMetadataReceived = (hasMetadata, queryId) => {
  return (dispatch) => {
    dispatch({
      type: "SET_FINAL_METADATA_RECEIVED",
      payload: { hasMetadata, queryId },
    });
  };
};

export const setShouldCollapseReasoning = (shouldCollapse, queryId) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SHOULD_COLLAPSE_REASONING",
      payload: { shouldCollapse, queryId },
    });
  };
};

export const resetStreamingStates = (queryId) => {
  return (dispatch) => {
    dispatch({
      type: "RESET_STREAMING_STATES",
      payload: { queryId },
    });
  };
};

export const setContentStarted = (hasStarted, queryId) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CONTENT_STARTED",
      payload: { hasStarted, queryId },
    });
  };
};

export const setDeleteAccountReasonList = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DELETE_ACCOUNT_REASON_LIST",
      value: value,
    });
  };
};

export const setAuthLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_AUTH_LOADER",
      value: value,
    });
  };
};

export const setNegativeFeedbackReasonList = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_NEGATIVE_FEEDBACK_REASON_LIST",
      value: value,
    });
  };
};

export const setGlobalSearchChatList = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_GLOBAL_SEARCH_CHAT_LIST",
      value: value,
    });
  };
};
export const setGlobalSearchChatLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_GLOBAL_SEARCH_CHAT_LOADER",
      value: value,
    });
  };
};
export const setShareChatID = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SHARE_CHAT_ID",
      value: value,
    });
  };
};

export const setChatsStreamLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CHATS_STREAM_LOADER",
      value: value,
    });
  };
};

export const setSignUpFailedFlag = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SIGN_UP_FAILED_FLAG",
      value: value,
    });
  };
};

export const setChartsArtifactLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_CHARTS_ARTIFACT_LOADER",
      value: value,
    });
  };
};

export const showBlurredBackground = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SHOW_BLURRED_BACKGROUND",
      value: value,
    });
  };
};

export const setPersona = (persona) => {
  return {
    type: "SET_PERSONA",
    value: persona,
  };
};